export default __webpack_public_path__ + "static/media/404-error-page2.370f962e.svg";